import { btMediumGrayColor, btNavyBlueColor, webPrimaryColor, btLightOrange } from '../../assets/jss/nextjs-material-kit-pro';
import { makeStyles } from '@material-ui/core/styles';

export const useSeniorListTableStyles = makeStyles((theme) => ({
  frame: {
    width: '100vw',
  },
  alignPage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  formatTableSize: {
    margin: '0 auto 0 auto',
    maxWidth: '1320px',
  },
  titlebar: {
    backgroundColor: '#fff',
    padding: '30px 10px 5px 10px',
    margin: '-15px 0 15px 0',
    borderBottom: '1px inset #f0f0f0',
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 600,
  },
  breadcrumb: {
    padding: '18px 0 0 10px',
  },
  breadCrumbText: {
    fontSize: '0.80rem',
  },
  noLeftPadding: {
    paddingLeft: '0 !important',
  },
  sortHeader: {
    cursor: 'pointer',
    color: btNavyBlueColor,
  },
  nosortHeader: {
    color: btMediumGrayColor,
  },
  idLink: {
    color: btNavyBlueColor,
    fontSize: '0.85rem',
    padding: 0,
  },
  idNoLink: {
    padding: 0,
  },
  gridLink: {
    color: btNavyBlueColor,
    fontSize: '0.75rem',
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
    },
    textTransform: 'none',
    textDecoration: 'underline',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  centerAlignContent: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 20,
    marginTop: '10px',
  },
  pointer: {
    cursor: 'pointer',
  },
  filter: {
    margin: '5px 0 15px 20px',
    borderRadius: '6px 0 0 6px',
  },
  toolMargins: {
    margin: '5px 0 0 20px',
  },
  switchLeadingText: {
    margin: '5px 20px 15px 0',
    lineHeight: '30px',
    verticalAlign: 'middle',
  },
  switchAlignment: {
    lineHeight: '28px',
    verticalAlign: 'middle',
  },
  noSeniorsMsg: {
    fontSize: '1.15rem',
    margin: 5,
  },
  whiteBg: {
    background: '#FFFFFF',
  },
  centerRadioSorting: {
    marginLeft: 20,
    marginRight: 20,
    justifyContent: 'space-between',
  },
  radioLabel: {
    fontSize: '0.85rem',
    fontWeight: 500,
    '& svg': {
      width: '1.25rem',
      height: '1.25rem',
    },
  },
  radioRow: {
    width: '100%',
    justifyContent: 'space-between',
  },
  selectDropdown: {
    color: '#333',
    backgroundColor: '#fff',
  },
  menuItem: {
    '&:hover': {
      color: '#fff',
      backgroundColor: '#8c857b',
    },
  },
  enhancedFilterButton: {
    marginTop: 5,
    minHeight: 37,
    borderRadius: '0 6px 6px 0',
  },
  cardContainer: {
    height: '200px',
    padding: '30px 20px',
  },
  card: {
    color: '#000',
    backgroundColor: 'rgba(217, 217, 217, 1)',
    margin: '0 10px',
    height: '100px',
  },
  completedCardContent: {
    padding: '5px 10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  completed: {
    width: '100%',
    color: '#000',
    paddingTop: 5,
    fontSize: '0.90rem',
    lineHeight: '1.225rem',
    fontWeight: 500,
  },
  totalSummary: {
    width: '100%',
    color: '#000',
    padding: '10px 0 5px 0',
    fontSize: '1.75rem',
    lineHeight: '1.425rem',
    textAlign: 'center',
  },
  enrollmentWarning: {
    fontStyle: 'italic',
    padding: '5px 15px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },

  cardHeader: {
    color: webPrimaryColor,
    fontSize: '1.175rem',
    lineHeight: '1.5rem',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: '10px',
  },
  cardButton: {
    color: btNavyBlueColor,
    backgroundColor: btLightOrange,
    cursor: 'pointer',
    width: '165px',
    borderRadius: '18px',
    fontWeight: 700,
  },
  menuTitle: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: '1.25rem',
    textAlign: 'left',
    margin: '20px 0 0 0',
  },
  cardIcon: {
    position: 'absolute',
    top: '-55px',
    left: '28%',
  },
}));
